var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"toolbar-layout"},[_c('img',{staticClass:"toolbar-layout__icon",attrs:{"src":require("@/assets/img/png/nav-logo.png")}}),_c('b-button',{attrs:{"type":"is-light","icon-left":"close"},on:{"click":function($event){return _vm.$emit('on-click')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }